// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"Sidebar_sidebarWrapper__hYLvK","list":"Sidebar_list__2pVNK","item":"Sidebar_item__yREVy","logo":"Sidebar_logo__04INu"};